import React, { useState, useEffect, useCallback } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";
import { set } from "date-fns";
import MultipleSelectDropdown from "../MultipleSelectDropdown";

function EditBroadcastNotification({
  show,
  handleClose,
  id,
  onOptionAdded,
  optionsData,
}) {
  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    scheduleTime: "",
    user: [],
    blog: "",
    isSend: 0,
  });

  const fetchBroadcastDetails = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/broadcast/${id}`
      );
      if (response.data.success) {
        const { title, scheduleTime, desc, userId, blogId } =
          response.data.data;
        const localSchedule = scheduleTime
          ? new Date(scheduleTime)
              .toLocaleString("en-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
              .replace(/,/, "")
              .replace(/ /g, "T")
          : "";

        let userData = "";
        if (userId?.length > 0) {
          const isAllSelect =
            optionsData?.userList?.data?.length === userId?.length;
          if (isAllSelect) {
            userData = [{ value: "all", label: "All Users" }];
          } else {
            userData = userId
              ?.map((userData) => {
                const user = optionsData?.userList?.data.find(
                  (userDetails) => userDetails._id === userData?._id
                );
                if (user) {
                  return {
                    value: user._id,
                    label: `${user.firstName} ${user.lastName}`,
                  };
                }
                return null;
              })
              .filter(Boolean);
          }
        } else {
          userData = [{ value: "all", label: "All Users" }];
        }

        const blogData = optionsData?.blogList?.data?.find(
          (blog) => blog._id === blogId?._id
        );

        setFormData((prevState) => ({
          ...prevState,
          title: title || "",
          desc: desc || "",
          scheduleTime: localSchedule,
          isSend: 1 || 0,
          user: userData || [],
          blog: blogData
            ? { value: blogData?._id, label: blogData?.title }
            : "",
        }));
      }
    } catch (error) {
      CustomToast.error(
        error.response?.data?.message || "Error fetching broadcast details"
      );
    }
  }, [id]);
  useEffect(() => {
    if (id) {
      fetchBroadcastDetails();
    } else {
      setFormData({
        title: "",
        desc: "",
        scheduleTime: "",
        isSend: 0,
      });
    }
  }, [id, fetchBroadcastDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      isSend: value,
    }));
  };

  const resetForm = () => {
    setFormData({
      title: "",
      desc: "",
      scheduleTime: "",
      isSend: 0,
      user: [],
      blog: "",
    });
  };

  const handleModalClose = () => {
    resetForm();
    handleClose();
  };

  const handleSubmit = async () => {
    try {
      if (!formData.user || Array.isArray(formData.user) && formData.user.length === 0) {
        CustomToast.error("Please select at least one user");
        return;
      }
      if (!formData.title.trim()) {
        CustomToast.error("Please enter a title");
        return;
      }
      if (!formData.desc.trim()) {
        CustomToast.error("Please enter a description");
        return;
      }
      if (formData.isSend === 1 && !formData.scheduleTime) {
        CustomToast.error("Please select a schedule time");
        return;
      }

      const { user, blog, ...restFormFields } = formData;
      const payload = {
        ...restFormFields,
        ...(restFormFields.scheduleTime
          ? {
              scheduleTime: new Date(restFormFields.scheduleTime).toISOString(),
            }
          : {}),
      };

      // if (user?.length > 0) {
      const isAllUsersSelected = user?.some((item) => item.value === "all");
      if (isAllUsersSelected) {
        const allUsersId = [];
        // const allUsersId = optionsData?.userList?.data.map(
        //   (user) => user._id
        // );
        Object.assign(payload, { userIds: allUsersId });
      } else {
        const selectedUserIds = user?.map((user) => user.value);
        Object.assign(payload, { userIds: selectedUserIds });
      }
      // }

      Object.assign(payload, { blogId: blog?.value || null });

      let response;
      if (id) {
        response = await axiosInstance.put(
          `${process.env.REACT_APP_BACKEND_URL}/api/broadcast/${id}`,
          payload
        );
      } else {
        response = await axiosInstance.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/notification/broadcast/send`,
          payload
        );
      }

      if (response.data.success) {
        const successMessage = id
          ? "Broadcast notification updated successfully"
          : formData.isSend === 1
          ? "Notification scheduled successfully"
          : "Notification sent successfully";
        CustomToast.success(successMessage);
        onOptionAdded();
        handleModalClose();
      }
    } catch (error) {
      console.log(error);
      CustomToast.error(
        error.response?.data?.message ||
          `Error ${id ? "updating" : "send"}  notification`
      );
    }
  };

  //  function for infinite scroll in react select

  const handleScrollUserDropDown = (e) => {
    // const { pagination } = optionsData.userList;
    // const totalPages = pagination?.totalPages || 1;
    // const bottom =
    //   e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    // if (bottom && pageState.user < totalPages && !optionLoading.userList) {
    //   const nextPage = pageState.user + 1;
    //   setPageState((prev) => ({ ...prev, user: nextPage }));
    //   fetchUsers({ page: nextPage });
    // }
  };
  const handleScrollBlogDropDown = (e) => {
    // const { pagination } = optionsData.blogList;
    // const totalPages = pagination?.totalPages || 1;
    // const bottom =
    //   e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    // if (bottom && pageState.blog < totalPages && !optionLoading.blogList) {
    //   const nextPage = pageState.blog + 1;
    //   setPageState((prev) => ({ ...prev, blog: nextPage }));
    //   fetchBlogs({ page: nextPage });
    // }
  };
  return (
    <>
      <Modal
        show={show}
        className="custom-modal"
        size="lg"
        centered
        scrollable
        onHide={handleModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {id ? "Edit" : "Add"} Broadcast Notification
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            <div className="col-xl-6">
              <Form.Group controlId="desc">
                <Form.Label>Users</Form.Label>
                <MultipleSelectDropdown
                  options={[
                    {
                      value: "all",
                      label: "Select all",
                    },
                    ...optionsData?.userList?.data.map((item) => ({
                      value: item._id,
                      label: `${item.firstName} ${item.lastName}`,
                    })),
                  ]}
                  value={formData.user}
                  isMulti
                  name="items"
                  id="items"
                  className="p-0"
                  placeholder="Select Users"
                  isSearchable
                  onChange={(selectedItems, e) => {
                    const isAllSelected = e?.option?.value == "all";
                    setFormData((prev) => ({
                      ...prev,
                      user: isAllSelected
                        ? [{ value: "all", label: "Select all" }]
                        : selectedItems?.filter((item) => item.value !== "all"),
                    }));
                  }}
                  // onScroll={handleScrollUserDropDown}
                />
              </Form.Group>
            </div>
            <div className="col-xl-6">
              <Form.Group controlId="desc">
                <Form.Label>Recipe blog</Form.Label>
                <MultipleSelectDropdown
                  options={[
                    {
                      value: "",
                      label: "Select Recipe blog",
                    },

                    ...optionsData?.blogList?.data.map((item) => ({
                      value: item._id,
                      label: item.title,
                    })),
                  ]}
                  value={formData.blog}
                  isMulti={false}
                  name="items"
                  id="items"
                  className="p-0"
                  placeholder="Select Blog"
                  isSearchable
                  onChange={(selectedItems, e) => {
                    setFormData((prev) => ({
                      ...prev,
                      blog: selectedItems,
                    }));
                  }}
                  // onScroll={handleScrollBlogDropDown}
                />
              </Form.Group>
            </div>
            <div className="col-xl-6">
              <Form.Group controlId="name">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  placeholder="Enter title"
                />
              </Form.Group>
            </div>
            {formData.isSend === 1 && (
              <div className="col-xl-6">
                <Form.Group controlId="scheduleTime">
                  <Form.Label>Schedule Time</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="scheduleTime"
                    value={formData.scheduleTime}
                    onChange={handleInputChange}
                    min={new Date().toISOString().split("T")[0]}
                    placeholder="Select time"
                    onClick={(e) => e.target.showPicker()}
                    onKeyDown={(e) => e.preventDefault()}
                    style={{ cursor: "pointer" }}
                  />
                </Form.Group>
              </div>
            )}

            <div className="col-xl-12">
              <Form.Group controlId="desc">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="desc"
                  value={formData.desc}
                  onChange={handleInputChange}
                  placeholder="Enter description"
                />
              </Form.Group>
            </div>

            <div className="col-xl-6">
              <Form.Group controlId="send">
                <Form.Label>Want to schedule ?</Form.Label>
                <div className="theme-radio d-flex align-items-center gap-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault1"
                      checked={formData.isSend === 1}
                      onChange={() => handleRadioChange(1)}
                      disabled={id && formData.isSend === 1}
                    />
                    <label className="form-check-label" htmlFor="radioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault2"
                      checked={formData.isSend === 0}
                      onChange={() => handleRadioChange(0)}
                      disabled={id && formData.isSend === 1}
                    />
                    <label className="form-check-label" htmlFor="radioDefault2">
                      No
                    </label>
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              className="btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-5"
              onClick={handleSubmit}
            >
              {formData.isSend === 0
                ? "Send notification now"
                : "Schedule notification"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default EditBroadcastNotification;
